import * as React from 'react';
const CustomDnbCreditcard = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.54 24.33" {...props}>
    <g data-name="Layer 2">
      <path
        d="M31.13.5H3.42A2.92 2.92 0 0 0 .5 3.42v17.5a2.91 2.91 0 0 0 2.92 2.91h27.71A2.91 2.91 0 0 0 34 20.92V3.42A2.91 2.91 0 0 0 31.13.5M.5 6.33H34"
        className="custom_dnb_creditcard_svg__cls-1"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
export default CustomDnbCreditcard;
